import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-200">
      <div className="w-full px-4 md:px-6">
        <div className="py-12 md:py-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-flower-line text-lg text-background-50"></i>
              </div>
              <span className="font-heading text-xl font-semibold text-background-50">
                百合会
              </span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed mb-4">
              百合会是为百合文化爱好者打造的核心聚集地，汇聚百合漫画、百合动漫、百合小说等优质内容与同好交流平台。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 rounded-lg bg-background-800 flex items-center justify-center hover:bg-primary-500 transition-colors" aria-label="微博">
                <i className="ri-weibo-line text-background-200"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-lg bg-background-800 flex items-center justify-center hover:bg-primary-500 transition-colors" aria-label="Bilibili">
                <i className="ri-bilibili-line text-background-200"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-lg bg-background-800 flex items-center justify-center hover:bg-primary-500 transition-colors" aria-label="微信公众号">
                <i className="ri-wechat-line text-background-200"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">内容分类</h4>
            <ul className="space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">快捷链接</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-background-400 hover:text-primary-400 transition-colors">首页</Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors">关于我们</Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors">联系我们</Link>
              </li>
              <li>
                <a href="#" className="text-sm text-background-400 hover:text-primary-400 transition-colors">加入社群</a>
              </li>
              <li>
                <a href="#" className="text-sm text-background-400 hover:text-primary-400 transition-colors">投稿指南</a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">联系我们</h4>
            <div className="space-y-3">
              <div className="flex items-start gap-3">
                <div className="w-8 h-8 rounded-lg bg-background-800 flex items-center justify-center shrink-0 mt-0.5">
                  <i className="ri-mail-line text-sm text-background-300"></i>
                </div>
                <span className="text-sm text-background-400">contact@yuriclub.cn</span>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-8 h-8 rounded-lg bg-background-800 flex items-center justify-center shrink-0 mt-0.5">
                  <i className="ri-map-pin-line text-sm text-background-300"></i>
                </div>
                <span className="text-sm text-background-400">北京市朝阳区百合大道100号</span>
              </div>
            </div>
          </div>
        </div>

        <div className="py-6 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; 2026 百合会 YuriClub. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors" rel="nofollow">隐私政策</a>
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors" rel="nofollow">服务条款</a>
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors" rel="nofollow">Cookie设置</a>
          </div>
        </div>
      </div>
    </footer>
  );
}